export default "__VITE_ASSET__BotNz6iD__"